import {initShare} from './share'

export function initProductShare() {
  const shareButton = document.querySelector('.js-share-button')
  if (shareButton) {
    initShare(shareButton)
  }
}

